import { gql } from '@apollo/client';
import { validateEmail } from '@arcadiapower/warbler';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const VALIDATE = gql`
  query Flex_ValidateEmail($email: String!) {
    validation {
      availableEmail(email: $email) {
        isValid
      }
    }
  }
`;

export const EmailTelesales = (props: InputComponentProps & { currentEmail: string }) => {
  const validate = async ({ apollo, value }) => {
    const { currentEmail } = props;

    if (!validateEmail(value)) return 'Please enter a valid email address';

    if (currentEmail !== value) {
      const { data } = await apollo.query({
        fetchPolicy: 'no-cache',
        query: VALIDATE,
        variables: { email: value },
      });

      if (!data.validation.availableEmail.isValid) return 'This email is already in use.';
    }

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="username"
      label="Email"
      name="email"
      placeholder="example@arcadia.com"
      validate={validate}
      {...props}
    />
  );
};
